module.exports = __webpack_public_path__ + "static/img/8.e7018b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/8.png
// module id = ncwL
// module chunks = 0